<script>
import { useHead } from '@vueuse/head';
import { computed, defineComponent, onMounted, ref } from 'vue';

import rectUtil from '@/utils/rect';

export default defineComponent({
  name: 'ZoomOnHover',
  props: {
    imgNormal: { required: true },
    imgZoom: { required: false, type: String },
    productName: { required: true, type: String },
    scale: { required: false, type: Number, default: 1.5 },
  },
  setup(props) {
    const normal = ref();
    const rootEl = ref();
    const hoverImg = ref();

    const move = (event) => {
      const offset = rectUtil.pageOffset(rootEl.value);
      const relativeX = event.clientX - offset.x + window.pageXOffset;
      const relativeY = event.clientY - offset.y + window.pageYOffset;
      const normalFactorX = relativeX / normal.value.offsetWidth;
      const normalFactorY = relativeY / normal.value.offsetHeight;
      const x =
        normalFactorX * (hoverImg.value.offsetWidth * props.scale - normal.value.offsetWidth);
      const y =
        normalFactorY * (hoverImg.value.offsetHeight * props.scale - normal.value.offsetHeight);
      hoverImg.value.style.left = `${-x}px`;
      hoverImg.value.style.top = `${-y}px`;
    };

    const unzoom = () => {
      hoverImg.value.style.opacity = 0;
      normal.value.style.opacity = 1;
    };
    const zoom = () => {
      hoverImg.value.style.opacity = 1;
      hoverImg.value.style.transition = 'opacity 1s ease-in-out 0s';
      normal.value.style.opacity = 0;
    };

    onMounted(() => {
      hoverImg.value.style.transform = `scale(${props.scale})`;
    });

    useHead(
      computed(() => ({
        link: [
          {
            rel: 'preload',
            as: 'image',
            fetchpriority: 'high',
            href: props.imgNormal,
          },
        ],
      })),
    );

    return {
      hoverImg,
      move,
      normal,
      rootEl,
      unzoom,
      zoom,
    };
  },
});
</script>

<template>
  <div class="zoom-on-hover" ref="rootEl" @mouseenter="zoom" @mouseleave="unzoom" @mousemove="move">
    <img
      class="normal"
      ref="normal"
      :src="imgNormal"
      :alt="`${productName} image normal`"
      fetchpriority="high"
    />
    <img
      class="zoom"
      ref="hoverImg"
      :src="imgZoom || imgNormal"
      :alt="`${productName} image zoom`"
    />
  </div>
</template>

<style lang="scss" scoped>
.zoom-on-hover {
  position: relative;
  overflow: hidden;
  text-align: center;
  img.normal {
    object-fit: contain;
    max-height: 453px;
    width: 100%;
  }
  img.zoom {
    min-width: 100%;
    opacity: 0;
    position: absolute;
    transform-origin: top left;
  }
}
</style>
